// Column width (spec: docs/plottrack/plot-track-time-people-and-canon-room-spec.md §3).
// Standard is today's content-sized columns; narrow and wide are fixed widths.
export const WIDTH_PRESETS = { narrow: 140, standard: null, wide: 280 };
export const WIDTH_STEP = 20;
export const WIDTH_MIN = 140;
export const WIDTH_MAX = 800;

export function clampWidth(px) {
  return Math.max(WIDTH_MIN, Math.min(WIDTH_MAX, Math.round(px)));
}

/** The width a scene column is drawn at, in px, or null for content-sized. */
export function columnWidthPx(column, bookWidth) {
  if (column?.width_px) return clampWidth(column.width_px);
  return WIDTH_PRESETS[bookWidth] ?? null;
}

/** Inline style for a scene's header and cells. Empty for content-sized columns. */
export function widthStyle(px) {
  if (!px) return undefined;
  return { width: `${px}px`, minWidth: `${px}px`, maxWidth: `${px}px`, overflowWrap: 'anywhere' };
}
